export default function errorRedirect() {
  if (typeof window === 'undefined') return
  if (typeof window !== 'undefined') {
    window.location.pathname = '/error'
  }
}
